declare var __COMMIT_HASH__;
export const version = `${process.env.RAZZLE_VERSION}-${__COMMIT_HASH__}`;
